import gql from 'graphql-tag';
export const AvailabilityCalendarQuery = gql`
    query getTravelerStayQuery($conversationId: String!) {
        getTravelerStay(conversationId: $conversationId) {
            booking {
                listing {
                    houseRules {
                        children {
                            allowed
                        }
                        maxOccupancy {
                            adults
                            guests
                        }
                    }
                    minStayRange {
                        minStayLow
                        minStayHigh
                    }
                    sleeps
                }
                stayAvailability {
                    availabilityDefault
                    availabilityUpdated
                    changeOverDefault
                    dateRange {
                        beginDate
                        endDate
                    }
                    maxStayDefault
                    minPriorNotifyDefault
                    minStayDefault
                    source
                    stayIncrementDefault
                    sameDayCheckinAvailable
                    unitAvailabilityConfiguration {
                        availability
                        changeOver
                        checkInAvailability
                        maxStay
                        minPriorNotify
                        minStay
                        stayIncrement
                    }
                }
            }
        }
    }
`;
